import { BadgeColor, type BadgeColorType } from '@tundr/ds-components';
import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
import { HrRoleArchetype } from '../config/hr.types.ts';

export type RoleAccent = 'sand' | 'green' | 'indaco' | 'neutral';

export type RoleAccentConfig = {
  accent: RoleAccent;
  badgeColor: BadgeColorType;
  icon: TUNDR_ICONS;
};

const ROLE_ACCENT_BY_ARCHETYPE: Record<HrRoleArchetype, RoleAccentConfig> = {
  [HrRoleArchetype.ADMIN]: {
    accent: 'indaco',
    badgeColor: BadgeColor.INFO,
    icon: TUNDR_ICONS.AWARD,
  },
  [HrRoleArchetype.MANAGER]: {
    accent: 'green',
    badgeColor: BadgeColor.SUCCESS,
    icon: TUNDR_ICONS.PEN,
  },
  [HrRoleArchetype.VIEWER]: {
    accent: 'sand',
    badgeColor: BadgeColor.NEUTRAL,
    icon: TUNDR_ICONS.EYE_OPEN,
  },
};

const DEFAULT_ROLE_ACCENT: RoleAccentConfig = {
  accent: 'neutral',
  badgeColor: BadgeColor.NEUTRAL,
  icon: TUNDR_ICONS.EYE_OPEN,
};

export const getRoleArchetype = (roleId: string): HrRoleArchetype | null => {
  const id = roleId.toLowerCase();
  if (id.includes('admin')) return HrRoleArchetype.ADMIN;
  if (id.includes('manager')) return HrRoleArchetype.MANAGER;
  if (id.includes('viewer')) return HrRoleArchetype.VIEWER;
  return null;
};

export const getRoleAccent = (roleId: string): RoleAccentConfig => {
  const archetype = getRoleArchetype(roleId);
  return archetype ? ROLE_ACCENT_BY_ARCHETYPE[archetype] : DEFAULT_ROLE_ACCENT;
};
